import tool from '@/utils/tool'

const hasOwnProperty = function (obj, key) {
    if ('object' !== typeof obj) {
        return false;
    }
    return Object.prototype.hasOwnProperty.call(obj, key);
}

export default {
    namespaced: true,
    state: {
        data: tool.data.get('baseconfig'),
    },
    // 外部方法
    actions: {
        setConfig({
            commit,
            data
        }) {
            commit('setConfig', data)
        },
        getConfig: ({state}, name) => {
            name = name || '';
            if (name) {
                try {
                    return state.data[name]
                } catch (error) {
                    return null
                }
            } else {
                return state.data
            }
        }
    },
    // 获取数据
    getters: {
        getConfig: (state, name) => {
            name = name || '';
            if (name) {
                try {
                    return state.data[name]
                } catch (error) {
                    return null
                }
            } else {
                return state.data
            }
        }
    },
    // 内部设置方法
    mutations: {
        setConfig(state, data) {
            if (hasOwnProperty(data, 'sitename') && hasOwnProperty(data, 'title')) {
                if (data.title) {
                    document.title = data.sitename + '-' + data.title
                }
                else {
                    document.title = data.sitename
                }
            }

            if (this.hasOwnProperty(data, 'user_register_type')) {
                tool.data.set('user_register_type', JSON.parse(data.user_register_type) || ['1']);
            }

            if (this.hasOwnProperty(data, 'user_login_type')) {
                tool.data.set('user_login_type', data.user_login_type || 1);
            }

            if (this.hasOwnProperty(data, 'theme_simpleblue_nav_order')) {
                tool.data.set('nav_order', data.theme_simpleblue_nav_order || 0);
            }

            if (this.hasOwnProperty(data, 'theme_simpleblue_nav_kefu')) {
                tool.data.set('nav_kefu', data.theme_simpleblue_nav_kefu || 0);
            }

            if (this.hasOwnProperty(data, 'user_openapi_open')) {
                tool.data.set('user_openapi_open', data.user_openapi_open || 1);
            }

            tool.data.set('baseconfig', data);
            state.data = data
            // console.log('setConfig.data', data);

            // console.log('setConfig.data.sales_sort_type', data.sales_sort_type);
            // console.log('state.data', state.data);
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/config.js